AppBase.module('Components.PhoneMulticomplete', function (Module, App) {
  'use strict'

  var Token = App.Views.ItemView.extend({
    className: 'token token--imageToken is-removable',
    tagName: 'li',
    template: 'phone_multicomplete/token',

    behaviors: {
      SN_Theme: {},
    },

    ui: {
      remove: '.token-removeIcon',
    },

    icons: {
      x_8: {
        $parent: '@ui.remove',
        theme: 'n2',
      },
    },

    triggers: {
      'click @ui.remove': 'remove_token',
    },

    serializeData: function () {
      var data = this.model.toJSON()

      if (!data.abbreviation && data.meta_data) {
        data.abbreviation = data.meta_data.abbreviation
      }

      return data
    },
  })
  Module.Token = Token
})
